import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { FileService } from 'src/app/data/services/file.service';

@Component({
  selector: 'app-file-upload-list',
  templateUrl: './file-upload-list.component.html',
  styleUrls: ['./file-upload-list.component.scss'],
})
export class FileUploadListComponent implements OnInit {
  files: File[] = [];
  filePathOldStructure: string = '';
  @Output() onSuccess = new EventEmitter<FileDto[]>();
  @Output() onCancel = new EventEmitter<boolean>();

  uploadedFiles: FileDto[] = [];

  fails = 0;
  stopped = 0;
  showFailedMessage = false;
  successOrStopped = 0;

  constructor(
    private elementRef: ElementRef,
    private fileService: FileService,
    @Inject(MAT_DIALOG_DATA) private readonly data: {
      files: File[],
      filePathOldStructure: string
    }
  ) {}

  ngOnInit(): void {
    this.files = this.data.files.slice();
    this.filePathOldStructure = this.data.filePathOldStructure;
  }

  uploadFailed(emit: boolean) {
    if (emit) this.fails++;
    else this.fails--;
    this.statusCheck();
  }

  uploadStopped(emit: boolean) {
    this.stopped++;
    this.successOrStopped++;
    this.statusCheck();
  }

  uploadSuccess(emit: FileDto) {
    this.uploadedFiles.push(emit);
    this.successOrStopped++;
    this.statusCheck();
  }

  private statusCheck(): void {
    if (this.files.length == this.successOrStopped) {
      this.onSuccess.emit(this.uploadedFiles);
      return;
    }
    if (this.fails == 0) this.showFailedMessage = false;
    else if (this.files.length == this.successOrStopped + this.fails)
      this.showFailedMessage = true;
  }

  onCancelClicked() {
    this.files = [];
    this.uploadedFiles.forEach((f) => {
      this.fileService.delete(f.id!).toPromise();
    });
    this.onCancel.emit(true);
  }
}
